<template>
    <b-modal id="locale-string-detail-modal"
             :title="modalTitle"
             hide-footer
             size="xl"
             modal-class="default-modal"
             @hide="closeModal"
    >
        <div class="action-btns">
            <template v-if="mode === 'readOnly'">
                <div style="height: 32px"/>
            </template>
            <template v-else-if="mode === 'detail'">
                <b-button variant="outline-primary"
                          @click="changeMode('edit')"
                >
                    {{ $t('수정') }}
                </b-button>
            </template>
            <template v-else-if="mode === 'add'">
                <b-button variant="outline-primary"
                          form="locale-string-form"
                          type="submit"
                >
                    {{ $t('저장') }}
                </b-button>
            </template>
            <template v-else-if="mode === 'edit'">
                <b-button variant="outline-danger"
                          @click="confirmDelete"
                >
                    {{ $t('삭제') }}
                </b-button>
                <b-button variant="outline-primary"
                          form="locale-string-form"
                          type="submit"
                >
                    {{ $t('저장') }}
                </b-button>
                <b-button variant="outline-secondary"
                          @click="changeMode('detail')"
                >
                    {{ $t('취소') }}
                </b-button>
            </template>
        </div>
        <div class="tabs-container">
            <b-tabs v-model="tabIndex" class="default-tabs" :class="{'with-actions': mode !== 'add'}" content-class="mt-3">
                <b-tab :title="$t('기본 정보')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <LocaleStringDetail v-if="mode === 'detail' || mode ==='readOnly'" :detail-data="detailData"/>
                        <LocaleStringForm v-else ref="localeStringForm" :mode="mode" :detail-data="detailData"
                                          @updateDetailData="updateDetailData"
                        />
                    </template>
                </b-tab>
            </b-tabs>
        </div>
    </b-modal>
</template>

<script>
import {deleteLocalizedString, getLocalizedString} from '@shared_utils/api/projectSchema';

import LocaleStringDetail
    from '@shared/components/admin/pages/Management/ProjectSchema/LocaleString/LocaleStringDetail.vue';
import LocaleStringForm
    from '@shared/components/admin/pages/Management/ProjectSchema/LocaleString/LocaleStringForm.vue';

export default {
    name: 'LocaleStringModal',
    components: {
        LocaleStringForm,
        LocaleStringDetail,
    },
    props: {
        detailId: {
            type: [Number, String, null],
            default: null,
        }
    },
    data() {
        return {
            mode: 'detail', // detail | add | edit | readOnly
            tabIndex: 1,
            detailData: {id: null},
            loading: false,
        };
    },
    computed: {
        modalTitle() {
            if (this.mode === 'add') {
                return this.$t('다국어 문자열 등록');
            } else if (this.mode === 'edit') {
                return this.$t('다국어 문자열 수정');
            } else {
                return this.$t('다국어 문자열 상세');
            }
        },
        readOnly() {
            return this.mode === 'readOnly';
        }
    },
    watch: {
        detailId: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.fetchDetailData();
                } else {
                    this.detailData = {id: null};
                }
            }
        }
    },
    methods: {
        changeMode(mode) {
            this.mode = mode;
            this.tabIndex = 1;
        },
        closeModal() {
            if (this.mode === 'edit') {
                this.$refs.localeStringForm.resetForm();
            }
            this.mode = 'detail';
            this.$bvModal.hide('locale-string-detail-modal');
        },
        async fetchDetailData() {
            try {
                this.loading = true;
                const res = await getLocalizedString(this.detailId);
                this.detailData = res.data;
            } catch (e) {
                console.error(e);
                console.dir(e);
            } finally {
                this.loading = false;
            }
        },
        updateDetailData(detailData) {
            if (this.mode === 'add') {
                this.$emit('addData', detailData);
                this.closeModal();
            } else if (this.mode === 'edit') {
                this.$emit('updateDetailData', detailData);
                this.detailData = detailData;
                this.changeMode('detail');
            }
        },
        confirmDelete() {
            this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: this.$t('다국어 문자열 삭제'),
                message: this.$t('현 다국어 문자열을 삭제하시겠습니까?')
            })
                .then((v) => {
                    if (v) {
                        this.deleteCondition();
                    }
                });
        },
        deleteCondition() {
            deleteLocalizedString(this.detailData.key)
                .then(() => {
                    this.$EventBus.$emit('toast-success', this.$t('다국어 문자열 삭제'), this.$t('다국어 문자열이 성공적으로 삭제되었습니다.'));
                    this.$emit('deleteData', this.detailData.id);
                    this.closeModal();
                })
                .catch((error) => {
                    console.error(error);
                    // if(error?.response.status === 400){
                    //     const errorMsg = error?.response?.data;
                    //     if(errorMsg?.includes('Cannot delete locale-string. It is used by rule groups:')){
                    //         const match = errorMsg.match(/\[([^\]]*)\]/);
                    //
                    //         if (match) {
                    //             const h = this.$createElement;
                    //             const ruleGroup = match[1].replace(/'/g, '').split(', ');
                    //             const badges = ruleGroup.map(name => {
                    //                 return h(
                    //                     'b-badge',
                    //                     {
                    //                         props: { variant: 'warning' },
                    //                         class: 'mx-1 f-90'
                    //                     },
                    //                     name
                    //                 );
                    //             });
                    //
                    //             const messageVNode = h(
                    //                 'div',
                    //                 [
                    //                     h('p', '해당 조건은 아래 규칙 그룹에서 사용 중이므로 삭제할 수 없습니다.'),
                    //                     h('div', { class: 'mt-3' }, badges)
                    //                 ]
                    //             );
                    //
                    //            
                    //             this.$showModal({
                    //                 type: 'alert',
                    //                 state: 'error',
                    //                 title: this.$t('조건 삭제 오류'),
                    //                 message: messageVNode
                    //             });
                    //         }
                    //         return;
                    //     }
                    // }
                    this.$EventBus.$emit('toast-failure', this.$t('다국어 문자열 삭제'), this.$t('다국어 문자열 삭제 중 오류가 발생했습니다. 개발 팀에 문의해주세요.'));
                });
        }
    },
};
</script>

<style scoped lang="scss">

</style>
